import { BillingRoute } from '/@/modules/billing/constants/BillingRoute';
import { RouteConfig } from 'vue-router';

export const router: RouteConfig[] = [
  {
    path: `/${BillingRoute.PURCHASE_SUMMARY}`,
    name: BillingRoute.PURCHASE_SUMMARY,
    component: () => import('/@/modules/billing/pages/PurchaseSummaryPage.vue')
  }
];
